export default {"src":"/_next/static/media/phone.52f7be58.svg","height":116,"width":336,"blurWidth":0,"blurHeight":0};